module.exports = __webpack_public_path__ + "img/percentSign.5e2e5e8b.svg";